<template>
  <transition name="slide-x-transition" mode="out-in">
    <section class="individual-account-settings" v-show="ready">
      <v-container class="header" fill-height>
        <v-row class="mb-2">
          <v-col cols="12">
            <h1 class="header-title optus-highlight optus-highlight--yellow">
              Account details&nbsp;
            </h1>
            <basic-info class="mt-3" />
            <credential-info class="mt-3" />
            <password-info class="mt-3" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </transition>
</template>

<script>
import BasicInfo from '@/modules/auth/views/account/BasicInfo'
import CredentialInfo from '@/modules/auth/views/account/CredentialInfo'
import PasswordInfo from '@/modules/auth/views/account/PasswordInfo'
import Auth from '@/modules/auth/models/Auth'

export default {
  name: 'AccountSettings',
  components: {
    BasicInfo,
    CredentialInfo,
    PasswordInfo
  },
  data() {
    return {
      ready: false
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Auth.dispatch('me', 'teachers')
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  }
}
</script>

<style lang="scss" scoped></style>
